import * as React from "react";
import { StyleSheet } from "react-native";
//  import { useState } from "react"; a part of cleaner code
import { useNavigation } from "@react-navigation/native";
//  import TransactionList from "../components/TransactionList"; a part of cleaner code
import { loadTransactions } from "../../redux/actions/TransactionActions";
import { useSelector } from "react-redux";
//   import GlobalStyles from "../components/GlobalStyles"; a part of cleaner code
// import CustomIcon from "../components/CustomIcon"; a part of cleaner code
import TransactionsFilterForm from "../../components/TransactionsFilterForm";
// import { enableTransactionFilterModal } from "../redux/actions/UIStateActions";

export default function SpendingInsightsScreen() {
  var transactionsLoaded = useSelector(
    (state) => state.transaction.transactionsLoaded
  );
  if (!transactionsLoaded) loadTransactions();
  const navigation = useNavigation();

  // const transactions = useSelector((state) => state.transaction.processedTransactions);
  // const transactionsLoaded = useSelector((state) => state.transaction.transactionsLoaded);

  var investedAmount = useSelector((state) => state.transaction.sumInvested);
  var donatedAmount = useSelector((state) => state.transaction.sumDonated);
  var modalVisible = useSelector(
    (state) => state.uistate.transactionFilterModal
  );
  // const [modalVisible, setModalVisible] = useState(false);
  return <TransactionsFilterForm />;
}

// const styles = StyleSheet.create({}); a part of cleaner code
